var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsOptional, IsString, ValidateNested, } from 'class-validator';
import { CreateDetailForMaintenanceDto } from './create-detail-for-maintenance.dto';
export class CreateVehicleMaintenanceDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleMaintenanceDto.prototype, "vehicleId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreateVehicleMaintenanceDto.prototype, "incomingDate", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreateVehicleMaintenanceDto.prototype, "releasingDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleMaintenanceDto.prototype, "serviceCenter", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVehicleMaintenanceDto.prototype, "vehicleMileageAtMaintenance", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => CreateDetailForMaintenanceDto),
    IsOptional(),
    __metadata("design:type", Array)
], CreateVehicleMaintenanceDto.prototype, "details", void 0);
